import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-import-progress-toast-list',
  templateUrl: './import-progress-toast-list.component.html',
})
export class ImportProgressToastListComponent implements OnChanges {
  @Input() pendingImports: any[] = [];
  closedToastrs: any[] = [];
  @Output() refresh = new EventEmitter();

  onCloseToastr(event: any): void {
    this.pendingImports = this.pendingImports.filter((importItem: any) => importItem.id !== event.id);
    this.closedToastrs.push(event.id);
    if (event.refresh) {
      this.refresh.emit(event.id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pendingImports']) {
      this.pendingImports = (changes['pendingImports'].currentValue || []).filter((importItem: any) => !this.closedToastrs.includes(importItem.id));
    }
  }
}
